import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { ShopTiles } from '../components/home/ShopTiles';
import { IngredientMarquee } from '../components/home/IngredientMarquee';
import { RitualSetFeature } from '../components/home/RitualSetFeature';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ProductSection } from '../components/shop/ProductSection';
import { collections } from '../data/collections';
import { site } from '../data/site';
import { productsForCollection } from '../utils/products';
import { organizationJsonLd } from '../utils/seo';
import { useSeo } from '../hooks/useSeo';
export function Home() {
  useSeo({
    title: site.defaultTitle,
    description: site.defaultDescription,
    path: '/',
    jsonLd: organizationJsonLd()
  });
  const bestsellers = collections.find(c => c.slug === 'bestsellers');
  const top = bestsellers ? productsForCollection(bestsellers).filter(p => p.category !== 'sets').slice(0, 4) : [];
  return <>
      <HomeHero data-id="element-517" data-mp="30wjc8ok3us4c" />
      <ShopTiles data-id="element-518" data-mp="30xb5hsq8cdrg" />
      <IngredientMarquee data-id="element-519" data-mp="30vqak2006st2" />
      <ProductSection title="Bestsellers" subtitle="Waar onze klanten steeds weer voor terugkomen." link={{
      to: '/collectie/bestsellers',
      label: 'Alle bestsellers'
    }} products={top} data-id="element-520" data-mp="30w03nygchg2z" />
      <RitualSetFeature data-id="element-521" data-mp="2mx0gywce7b9g" />
      <ReviewsSection data-id="element-522" data-mp="2mxjork8bwj9r" />
    </>;
}